import {
    Typography,
    IconButton,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Stack,
} from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import React from 'react';

type IconKey = 'reset' | 'success';

interface actionsProps {
    label: string;
    icon: IconKey;
    variant: 'text' | 'contained' | 'outlined';
    handleClick: () => void;
    disabled?: boolean;
    loading?: boolean;
}

interface Props {
    children: any;
    showModal: boolean;
    title: string;
    subTitle: string;
    width?: string;
    disableBackdropClick?: boolean;
    disableEscapeKeyDown?: boolean;
    onModalClose: () => void;
    contentPadding?: string;
    actions?: null | actionsProps[] | any;
    fullWidth?: boolean;
    maxWidth?: 'md' | 'sm' | 'lg' | 'xs';
    
}

export const DialogBox: React.FC<Props> = (props: Props): React.ReactElement => {

    const {
        children,
        showModal,
        title,
        subTitle,
        width,
        disableBackdropClick,
        disableEscapeKeyDown,
        onModalClose,
        contentPadding,
        actions,
        fullWidth,
        maxWidth
    } = props;

    return (
        <Dialog
            open={showModal}
             onClose={(_event, reason) => {
               if (reason === "backdropClick") {
                    return;
                 }
                 onModalClose();
            }}
            sx={{ border: 'none', outline: 'none' }}
            fullWidth={fullWidth}
            maxWidth={maxWidth}
        >
            <DialogTitle
                sx={{
                    border: 'none',
                    outline: 'none',
                    padding: 2,
                    bgcolor: 'action.hover',
                }}
            >
                <Stack direction="column" alignItems="flex-start" gap={0.5}>
                    <Typography variant="body1" color="text.primary">
                        {title}
                    </Typography>
                    {subTitle && (
                        <Typography variant="body2" color="text.secondary">
                            {subTitle}
                        </Typography>
                    )}
                </Stack>
            </DialogTitle>

            <IconButton
                aria-label="close"
                onClick={onModalClose}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}
            >
                <CloseOutlinedIcon />
            </IconButton>
            <DialogContent sx={{ p: 0 }}>{children}</DialogContent>
            {
                actions && actions.length > 0 && (
                    <DialogActions
                        sx={{
                            padding: 2,
                            bgcolor: 'action.hover',
                        }}
                    >
                        {actions &&
                            actions.map((value: actionsProps) => (
                                <Button
                                    variant={value.variant}
                                    onClick={value.handleClick}
                                    key={value.label}
                                    disabled={value.disabled}
                                >
                                    {value.label}
                                </Button>
                            ))}
                    </DialogActions>

                )
            }
        </Dialog>
    );
}